export default __webpack_public_path__ + "static/media/ic_filter_expand.62607cd3.svg";